import { z } from 'zod';

// Using the new cancel reasons (Feb 2026) - excluding legacy reasons
export const DeclineJobRequestReasonSchema = z.enum([
  'access',
  'customer-cancellation',
  'equipment',
  'hangar',
  'maintenance-conflict',
  'manpower',
  'missed-ops-error',
  'hours-of-operation',
  'insufficient-notice',
  'weather',
  'special-event-volume',
  'duplicate',
]);

export type DeclineJobRequestReason = z.infer<typeof DeclineJobRequestReasonSchema> | 'other';
